import { useTranslation } from 'react-i18next'

// Reemplaza los 4 arrays de labels de estado de novedad que estaban
// duplicados (Novedades.tsx, NovedadDetails.tsx, HistorialDetails.tsx,
// Historial.tsx) por una única fuente traducida. El índice coincide con el
// NoveltyStatus del backend (pkg/models/novelty.go).
const STATUS_KEYS = [
  'pendingProcess',
  'inactive',
  'cancelled',
  'blocked',
  'processError',
  'successful',
  'pendingApproval',
  'rejected',
] as const

// Valores base (id/value) para armar selects de estado; el label se resuelve
// con useNoveltyStatusLabel() en el componente que los renderiza.
export const NOVELTY_STATUS_VALUES = STATUS_KEYS.map((_, index) => ({
  id: index + 1,
  value: index,
}))

// Clave de traducción (namespace "status") para un código de estado, para
// los pocos casos donde el renderCell vive fuera del árbol de React (p. ej.
// GridColDef.renderCell definido a nivel de módulo) y no puede usar el hook.
export const noveltyStatusI18nKey = (statusCode: number): string | undefined => {
  const key = STATUS_KEYS[statusCode]
  return key ? `novelty.${key}` : undefined
}

export const useNoveltyStatusLabel = () => {
  const { t } = useTranslation('status')
  return (statusCode: number): string => {
    const key = noveltyStatusI18nKey(statusCode)
    return key ? t(key) : String(statusCode)
  }
}
